import { ItemType } from '../generated/types'

/** Item Type narrowed to static */
export type StaticItemType = Omit<ItemType, 'detector'>

export function isStaticItemType(itemType?: ItemType): itemType is StaticItemType {
    return itemType?.generationType === 'static'
}
